import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SOFTWARE_REPO_STATUS_QUERY_KEY } from '@/hooks/queries/use-software-repo-status';
import { orgSoftwareConfigQueryKey } from '@/hooks/queries/use-org-software-config';
import {
  updateOrgSoftwareConfig,
  type UpdateOrgSoftwareConfig,
} from '@/services/org/org-software-config';

interface UpdateOrgSoftwareConfigVariables {
  orgId: string;
  update: UpdateOrgSoftwareConfig;
}

export const useUpdateOrgSoftwareConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ orgId, update }: UpdateOrgSoftwareConfigVariables) =>
      updateOrgSoftwareConfig(orgId, update),
    onSuccess: (config, { orgId }) => {
      queryClient.setQueryData(orgSoftwareConfigQueryKey(orgId), config);
      void queryClient.invalidateQueries({
        queryKey: [SOFTWARE_REPO_STATUS_QUERY_KEY, orgId],
      });
    },
  });
};
